import {
  companyPartnerIntegrationsService,
  IntegrationStatus,
  IntegrationType,
} from '@aslanpay/portal-common-lib';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateIntegrationTypeStatusParams {
  id: string;
  companyId: string;
  integrationType: IntegrationType;
  status: IntegrationStatus;
}

const useUpdateIntegrationTypeStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, integrationType, status }: UpdateIntegrationTypeStatusParams) =>
      companyPartnerIntegrationsService.updateTypeStatus(id, integrationType, { status }),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['fetchCompanyIntegrations', companyId] });
    },
  });
};

export default useUpdateIntegrationTypeStatus;
